import * as React from 'react'

import { Box, Icon, Popover, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

import List from './List'

interface VersionHistoryProps {
  histories: ShiftVersionHistory[]
  disabled?: boolean
}

const VersionHistory = ({ histories, disabled }: VersionHistoryProps) => {
  const [open, toggle] = useToggle(false)

  if (!!disabled) return <Icon.Medium icon="history" color="grey400" />

  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
      title={i18n.t('clock_in.history.title')}
    >
      <Box cursor="pointer" padding="s4">
        <Icon.Medium icon="history" color="viridian1000" />
      </Box>
      <List histories={histories} />
    </Popover.ItemList>
  )
}

export default VersionHistory
